<template>
<div class="col-12 col-md-4 mb-3 card-wrap">
    <div class="card h-100 card-clinical_trial bg-white p-4" :data-locations="location_ids">
        <div class="card-background-image" v-if="background_image">
            <img src="background_image" alt="">
        </div>
        <div class="card-body px-0 pt-0 d-flex flex-column">
            <div class="card-title mb-2">
                <h5>{{ title }}</h5>
            </div>
            <div class="card-description">
                <p>{{ excerpt }}</p>
            </div>
            <div class="clinical-details">
                <div class="cancer-types" v-if="cancer_types">
                    <h6>Cancer Types:</h6>
                    <div class="d-inline" v-html="cancer_types"></div>
                </div>
                <div class="therapy-lines" v-if="therapy_lines">
                    <h6>Lines of Therapy:</h6>
                    <div class="d-inline">{{ therapy_lines }}</div>
                </div>
                <div class="locations" v-if="locations">
                    <h6>Locations:</h6>
                    <ul class="list-unstyled d-inline">
                        <li v-for="(location, index) in locations" :key="location.url" class="d-inline">
                            <a :href="location.url" target="_blank"><span v-html="location.title"></span></a><template v-if="index !== locations.length - 1">, </template>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="card-footer p-0">
            <a class="btn btn-primary" :href="trial_link" target="_blank"
                aria-label="View Details on clinicaltrials.gov">
                View Details on ClinicalTrials.gov
            </a>
        </div>
    </div>
</div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  props: ['post'],
  data() {
    return {
        title: '',
        excerpt: '',
        trial_link: '',
        cancer_types: '',
        therapy_lines: '',
        location_ids: '',
        locations: []
    }
  },
  computed: {

  },
  methods: {
    renderPost(){
        this.title = this.$props.post['title']
        this.excerpt = this.$props.post['excerpt']
        this.trial_link = this.$props.post['trial_link']
        this.cancer_types = this.$props.post['cancer_types'].join(', ')
        this.therapy_lines = this.$props.post['therapy_lines'].join(', ')
        this.location_ids = this.$props.post['location_ids'].join(', ')
        this.locations = this.$props.post['locations']
    }
  },
  created() {
    this.renderPost()
  }
}
</script>